module.exports = __webpack_public_path__ + "static/media/Camilo Cuba Headshot_1629322527597.a07c727f.jpeg";